

<template>
  <div class="shippingDetails">
    <header class="fixed_Back_header flx">
      <div class="menu flx">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#FFF" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h3>{{$t("orderCancel")}}</h3>
      </div>
    </header>
    <section class="main_content">
      <div class="order-id-block">
        <p>
          Order ID:
          <b>#{{orderDetails.orderId}}</b>
        </p>
        <p>
          {{$t('currentState')}}:
          <b
            :class="{'cancel': orderDetails.currentOrderState =='Cancelled','delivered': orderDetails.currentOrderState =='Delivered'}"
          >{{orderDetails.currentOrderState}}</b>
        </p>
      </div>

      <div
        class="product-card"
        v-if="subOrderDetails"
        @click="goToProductDetail(subOrderDetails.saleReferenceID,'NORMAL')"
      >
        <span class="product-img" v-if="subOrderDetails.itemImage">
          <img :src="subOrderDetails.itemImage" alt="suborder" />
        </span>
        <div class="product-detail">
          <div class="product-title">
            <h4>{{subOrderDetails.itemName}}</h4>
            <span class="product-price">Rs. {{subOrderDetails.sellingPrice}}</span>
          </div>
          <div class="color-size">
            <span class="product-color" v-if="subOrderDetails.color">
              {{$t('color')}} :&nbsp;
              <span class="colour">
                <span>{{subOrderDetails.color}}</span>
              </span>
            </span>
            <span class="product-sz" v-if="subOrderDetails.size">
              {{$t('size')}} :&nbsp;
              <span class="size">{{subOrderDetails.size}}</span>
            </span>
          </div>
          <p v-if="orderDetails.orderDate">
            {{$t('orderDate')}}: {{ orderDetails.orderDate.slice(0, orderDetails.orderDate.indexOf(',')) }} | Mode:
            <span
              v-if="orderDetails.paymentMethod !='COD'"
            >Online</span>
            <span v-else>{{orderDetails.paymentMethod}}</span>
          </p>
          <p
            v-if="!['ORDER_DELIVERED', 'CANCELLED_BY_SELLER', 'CANCELLED_BY_USER'].includes(orderDetails.orderState)"
          >{{$t('deliveryDate')}}: {{ orderDetails.expectedDeliveryDate }}</p>
        </div>
      </div>
      <div class="product-card">
        <p
          class="cancel_msg"
        >{{$t('orderCancelMsg')}}</p>
      </div>
      <div class="shipping_button cancel_button">
        <button type="button" class="order-track-btn" @click="cancelOrder()">{{$t('orderCancel')}}</button>
      </div>
    </section>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <div class="customModal" v-if="CancelModal">
      <div class="modal_dialog Cod">
        <div class="modal_content">
          <h3>{{$t('doYouReallyWantToCancel')}}</h3>

          <div class="modal_footer alert_btn">
            <button
              type="button"
              class="yes"
              @click="orderCancelModel(orderDetails.orderId)"
            >{{$t('yes')}}</button>
            <button type="button" class="no" @click="CancelModal = !CancelModal">{{$t('later')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constant from "../../utils/constant";
import "../../assets/css/order-history.scss";
import { bus } from "../../main";
import ImageSpinner from "../Common/ImageSpinner";
export default {
  name: "CancelOrder",
  components: {
    ImageSpinner
  },
  data() {
    return {
      orderDetails: {},
      extraDis: false,
      codEnabled: true,
      showCancel: true,
      orderDetails: {},
      subOrderDetails: {},
      loading: false,
      preloader: true,
      comment: "",
      reason: "",
      listedReasons: [],
      CancelModal: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToOrderDetail() {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/shippingDetails/" + this.$route.params.orderId);
    },
    getOrdersById() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "orderById",
          payload: this.$route.params.orderId
        })
        .then(data => {
          this.preloader = false;
          this.orderDetails = data.data;
          if (
            this.orderDetails &&
            this.orderDetails.subOrderDTOList &&
            this.orderDetails.subOrderDTOList.length > 0
          ) {
            this.subOrderDetails = this.orderDetails.subOrderDTOList[0];
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    goToProductDetail(productSrId, type) {
      this.$cookie.delete("type");
      this.$cookie.set("type", type);
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/detail/" + productSrId);
    },
    orderCancelModel(id) {
      this.loading = true;
      this.showCancel = false;
      this.CancelModal = false;
      var obj = {
        orderState: "CANCELLED_BY_USER"
      };
      this.$store
        .dispatch({
          type: "CancelUserOrder",
          payload: obj,
          orderId: id
        })
        .then(data => {
          this.loading = false;
          if (data.data.requestStatus == "SUCCESS") {
            this.$store.commit("saveData", {
              orders: [],
              orderIndex: 1,
              type: "post_order"
            });
            setTimeout(() => {
              this.$router.replace("/order-history");
            }, 1000);
          }
        })
        .catch(err => {
          this.loading = false;
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    },
    cancelOrder() {
      this.CancelModal = true;
    }
  },
  mounted() {
    if (this.$route.params.orderId) {
      this.getOrdersById();
    }
  }
};
</script>
